// POM-5910 — shared AG Grid valueFormatter for optional text columns.
//
// `manufacturer` is nullable on InventoryItem (the inventory-master row can be
// missing for an item), and it is rendered by both dashboard tables. Keeping one
// formatter means the two grids cannot drift into showing a blank cell in one
// place and an em dash in the other.
//
// Empty string and whitespace-only values fall back too: an all-space cell is
// indistinguishable from a blank one on screen, so it should read as "no value"
// rather than as a value that happens to be invisible.
export const dashIfEmpty = ({ value }) =>
  typeof value === 'string' && value.trim().length > 0 ? value : '—';

export default dashIfEmpty;
